import styled from '@mui/system/styled';

export const DeleteCnt = styled('div')({
  position: 'absolute',
  top: 8,
  right: -43,
});
